/**
 * IMPORTS
 */
import {
  useContagemNotificacoes,
  useSomNotificacoes,
} from "@/hooks/conversa-cliente/use-notificacoes";

/**
 * Montado uma única vez no layout autenticado: toca o som quando chega notificação nova,
 * em qualquer tela. Sem a feature `acessar_notificacoes` a contagem nem é consultada.
 */
function MonitorSomNotificacoes() {
  // único responsável pelo polling da contagem (sino e menu só leem o cache)
  const { data: naoLidas } = useContagemNotificacoes({ polling: true });
  useSomNotificacoes(naoLidas);
  return null;
}

/**
 * EXPORTS
 */
export { MonitorSomNotificacoes };
